import React from "react";
import { withSafeRotateSvg } from "../../hoc/withSafeRotateSvg";

const CurvedBorderCircular: React.FC<DogsTrust.CurveProps> = ({
	fill = "#FFC800",
	className,
	style,
}) => {
	return (
		<svg
			className={className}
			style={style}
			aria-hidden="true"
			focusable="false"
			viewBox={"0 0 414 95.33"}
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMidYMid slice"
		>
			<path
				d="M207 85.33C121.07 85.33 45.24 51.53 0 0v95.33h414V0c-45.24 51.53-121.07 85.33-207 85.33Z"
				style={{
					fill: fill,
				}}
			/>
		</svg>
	);
};

export default withSafeRotateSvg<DogsTrust.CurveProps>(CurvedBorderCircular);
